var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"analytics-placeholder"},[_c('h1',{staticClass:"analytics-placeholder__title"},[_vm._t("default")],2),_c('img',{staticClass:"analytics-placeholder__img",attrs:{"loading":"lazy","src":require("@/assets/images/analytics-chart-placeholder.webp"),"alt":"Нет данных"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }